
// Site Wide Funcitons

document.addEventListener("DOMContentLoaded", function(event) {
	siteWideFunctions();	
});

window.addEventListener('resize', browserHeight);

var lazyLoadInstance;

function siteWideFunctions() {

	lazyLoadInstance = new LazyLoad({
		elements_selector: ".lazy"
	});
	hoverImages();

	eventListeners();
	initialiseCarousels();
	newsletterSignup();
	pageScrolling();
	browserHeight();

	if(document.querySelector('.enquiry--form')) {
		enquiryFormFunctions();
	}
	
	if(document.querySelector('.detailed-product--single')) {
		productFunctions();
	}

	// Before productFiltering(), which builds on it.
	if(document.querySelector('.product--grid[data-pages]')) {
		collectionPaging = collectionPages();
	}

	if(document.querySelector('.product--sidebar')) {
		productFiltering();
	}
	if(document.querySelector('.open-side--panel')) {
		openSidePanel();
	}
	if(document.querySelector('.featured-products--collection')) {
		featuredCollections();
	}
	if(document.querySelector('.contact-form--navigation')) {
		contactPageFunctions();
	}
	if(document.querySelector('.archive-ring--card')) {
		archiveRingFunction();
	}
	if(document.querySelector('.mobile-dropdown')) {
		mobileDropdowns();
	}

	if(document.querySelector('.hero-video')) {
		heroVideo();
	}

	if (document.querySelector('.product--enquiry') && window.location.href.indexOf("?contact_posted=true") > -1) {
		formSuccess();
	}
}

// Product Card Hover Images (TY-109)

// The overlay a product card shows on hover (snippets/product.liquid) has its
// own photos, marked .lazy-hover so the LazyLoad above leaves them alone. On a
// screen without hover they are never loaded, and the overlay is not shown
// (assets/product.scss). With a mouse, nothing is fetched until it first moves
// over a product; from then on this LazyLoad loads the overlays near the
// screen, and the card under the mouse straight away. An overlay with its own
// hover_image hides the second photo, so that one is skipped.

var hoverLazyLoad;
var HOVER_IMAGES = '.product--overlay > .lazy-hover, .product--overlay .product--imagery:not(.hidden) .lazy-hover';

function hoverImages() {
	if(!window.matchMedia || !window.matchMedia('(hover: hover)').matches) {
		return;
	}

	document.addEventListener('mouseover', function(e) {
		var card = e.target.closest && e.target.closest('.single-product--card');
		if(!card) {
			return;
		}
		if(!hoverLazyLoad) {
			hoverLazyLoad = new LazyLoad({
				elements_selector: HOVER_IMAGES
			});
		}
		// load() skips an image LazyLoad has already processed.
		var images = card.querySelectorAll(HOVER_IMAGES);
		for (var i = 0; i < images.length; i++) {
			hoverLazyLoad.load(images[i]);
		}
	});
}

// Picks up product cards added to the page (Load more, filtering).
function updateLazyImages() {
	if(lazyLoadInstance && typeof lazyLoadInstance.update === 'function') {
		lazyLoadInstance.update();
	}
	if(hoverLazyLoad) {
		hoverLazyLoad.update();
	}
}

// Collection Pages (TY-109)

// The collection template shows 20 products a page. Load more fetches the next
// page and adds its cards to the end of the grid, where they fade in; the
// filtering (tagFiltering) needs the whole collection, which it gets from the
// collection.filter-data template, 250 products a request. Both go through
// here, so no product is added twice and cards always sit in collection order,
// whichever asked for them first.
//
// Every product card carries data-page, its page in the 20-a-page numbering.
// Unfiltered, the grid shows this page and the ones Load more has added (up to
// shownThrough); cards fetched for the filters stay hidden until a filter
// matches them or Load more reaches them. The More Products card closes the
// grid only once every page is showing, so it never looks like the end of the
// collection while there is more to load.
//
// Leaving for a product and coming back keeps the added pages: the count and
// scroll position are kept in sessionStorage for this address, and a
// back/forward or reload fetches those pages again and restores the scroll.

var collectionPaging = null;

function collectionPages() {
	var grid = document.querySelector('.product--grid[data-pages]');
	var pages = parseInt(grid.getAttribute('data-pages'), 10) || 1;
	var current = parseInt(grid.getAttribute('data-current-page'), 10) || 1;
	var perPage = parseInt(grid.getAttribute('data-per-page'), 10) || 20;
	var total = parseInt(grid.getAttribute('data-total'), 10) || 0;
	var moreCard = grid.querySelector('.more-products');
	var button = document.querySelector('[data-load-more]');
	var shownCount = document.querySelector('[data-shown-count]');
	var storageKey = 'ag:collection-pages:' + window.location.pathname + window.location.search;
	var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	var requests = {};
	var allRequest = null;
	var canFetch = !!(window.fetch && window.DOMParser);

	var ownCards = grid.querySelectorAll('.single-product--card[data-tags]');
	for (var i = 0; i < ownCards.length; i++) {
		ownCards[i].setAttribute('data-page', current);
	}

	var paging = {
		pages: pages,
		current: current,
		shownThrough: current,
		canFetch: canFetch,
		// tagFiltering replaces these: it decides what shows while filtered, and
		// adds the filter options a fetched page brings.
		refresh: showLoadedPages,
		onOptions: null,
		fetchPage: fetchPage,
		fetchAll: fetchAll,
		isShown: function(card) {
			var page = parseInt(card.getAttribute('data-page'), 10);
			return page >= current && page <= paging.shownThrough;
		},
		updateButton: updateButton
	};

	if(button && canFetch) {
		button.addEventListener('click', function(e) {
			e.preventDefault();
			// detail is 0 for Enter/Space, which is when focus has to follow.
			loadMore(e.detail === 0);
		});

		// Fetched while the visitor scrolls towards the button, so the click is
		// usually instant. The cards stay hidden, and their photos unloaded,
		// until it is pressed.
		if('IntersectionObserver' in window) {
			new IntersectionObserver(function(entries) {
				if(entries[0].isIntersecting && paging.shownThrough < pages) {
					fetchPage(paging.shownThrough + 1);
				}
			}, { rootMargin: '800px 0px' }).observe(button);
		}
	}

	restore();
	window.addEventListener('pagehide', remember);

	return paging;

	function loadMore(fromKeyboard) {
		var next = paging.shownThrough + 1;
		if(next > pages || button.getAttribute('aria-busy') === 'true') {
			return;
		}
		button.setAttribute('aria-busy', 'true');
		button.classList.add('is-loading');

		fetchPage(next).then(function(ok) {
			button.removeAttribute('aria-busy');
			button.classList.remove('is-loading');
			if(!ok) {
				// The page itself still works as a plain link.
				window.location.href = button.href;
				return;
			}
			paging.shownThrough = next;
			paging.refresh();
			var added = grid.querySelectorAll('.single-product--card[data-page="' + next + '"]');
			appear(added);
			// The button has moved below the new cards; keyboard focus goes to
			// the first of them rather than being left behind. A mouse or a
			// finger keeps its place, with no focus ring on a card.
			if(fromKeyboard && added.length) {
				var link = added[0].querySelector('.product-link');
				if(link) {
					link.focus({ preventScroll: true });
				}
			}
		});
	}

	// The added row fades up into place, a card at a time.
	function appear(cards) {
		if(reduceMotion) {
			return;
		}
		for (var c = 0; c < cards.length; c++) {
			cards[c].style.animationDelay = (Math.min(c, 11) * 45) + 'ms';
			cards[c].classList.add('is-appearing');
			cards[c].addEventListener('animationend', function(e) {
				if(e.target === this) {
					this.classList.remove('is-appearing');
					this.style.animationDelay = '';
				}
			});
		}
	}

	function showLoadedPages() {
		var cards = grid.querySelectorAll('.single-product--card[data-tags]');
		for (var c = 0; c < cards.length; c++) {
			cards[c].style.display = paging.isShown(cards[c]) ? '' : 'none';
		}
		updateButton(false);
		updateLazyImages();
	}

	// Load more, its "Showing x of y" line and the More Products card. All are
	// hidden while a filter is active (the filtered results already cover every
	// page). The button goes once every page is showing, the More Products card
	// arrives then, and the wrapper goes too if nothing is left in it. The
	// button's link always points at the next page, for opening in a new tab or
	// without the script.
	function updateButton(filtered) {
		var next = paging.shownThrough + 1;
		var finished = next > pages;
		if(moreCard) {
			moreCard.style.display = (!filtered && finished) ? '' : 'none';
		}
		if(shownCount && !filtered) {
			var cards = grid.querySelectorAll('.single-product--card[data-tags]');
			var shown = 0;
			for (var c = 0; c < cards.length; c++) {
				if(paging.isShown(cards[c])) {
					shown++;
				}
			}
			shownCount.textContent = 'Showing ' + shown + ' of ' + (total || shown);
		}
		if(!button) {
			return;
		}
		var wrapper = button.closest('.collection-pagination');
		button.style.display = (filtered || finished) ? 'none' : '';
		if(wrapper) {
			wrapper.style.display = (filtered || (finished && !wrapper.querySelector('a:not([data-load-more])'))) ? 'none' : '';
		}
		if(!finished) {
			button.href = pageUrl({ page: next });
		}
	}

	function pageUrl(params) {
		var url = new URL(window.location.href);
		for (var key in params) {
			if(params.hasOwnProperty(key)) {
				url.searchParams.set(key, params[key]);
			}
		}
		url.hash = '';
		return url.toString();
	}

	function getDocument(url) {
		return fetch(url, { credentials: 'same-origin' })
			.then(function(response) {
				if(!response.ok) {
					throw new Error(response.status);
				}
				return response.text();
			})
			.then(function(html) {
				return new DOMParser().parseFromString(html, 'text/html');
			});
	}

	function addOptions(doc) {
		if(paging.onOptions) {
			paging.onOptions(doc.querySelectorAll('.product--sidebar .selection[data-filter-value]'));
		}
	}

	// Resolves true once the page's cards are in the grid (hidden), false if
	// the request failed, which can then be tried again.
	function fetchPage(page) {
		if(!canFetch || page < 1 || page > pages || page === current) {
			return Promise.resolve(page === current);
		}
		if(!requests[page]) {
			requests[page] = getDocument(pageUrl({ page: page }))
				.then(function(doc) {
					addCards(page, doc.querySelectorAll('.product--grid .single-product--card[data-tags]'));
					addOptions(doc);
					return true;
				})
				.catch(function() {
					delete requests[page];
					return false;
				});
		}
		return requests[page];
	}

	// The whole collection, for the filters: templates/collection.filter-data
	// renders 250 cards and their sidebar options a request, in the same order,
	// so a card's place in it gives its page here. Pages it brings in count as
	// fetched for Load more. If that template can't be reached, the pages are
	// fetched one at a time instead.
	function fetchAll() {
		if(!canFetch || pages < 2) {
			return Promise.resolve();
		}
		if(!allRequest) {
			allRequest = fetchFilterData(1).then(function(dataPages) {
				if(!dataPages) {
					return fetchEveryPage();
				}
				var rest = [];
				for (var d = 2; d <= dataPages; d++) {
					rest.push(fetchFilterData(d));
				}
				return Promise.all(rest);
			});
		}
		return allRequest;
	}

	// Resolves the number of filter-data pages, or 0 if the request failed.
	function fetchFilterData(dataPage) {
		return getDocument(pageUrl({ view: 'filter-data', page: dataPage }))
			.then(function(doc) {
				var data = doc.querySelector('[data-filter-data]');
				if(!data) {
					throw new Error('no data');
				}
				var offset = parseInt(data.getAttribute('data-offset'), 10) || 0;
				var cards = data.querySelectorAll('.single-product--card[data-tags]');
				var byPage = {};
				for (var c = 0; c < cards.length; c++) {
					var page = Math.floor((offset + c) / perPage) + 1;
					(byPage[page] = byPage[page] || []).push(cards[c]);
				}
				for (var p in byPage) {
					if(byPage.hasOwnProperty(p)) {
						addCards(parseInt(p, 10), byPage[p]);
						if(!requests[p]) {
							requests[p] = Promise.resolve(true);
						}
					}
				}
				addOptions(doc);
				return parseInt(data.getAttribute('data-pages'), 10) || 1;
			})
			.catch(function() {
				return 0;
			});
	}

	function fetchEveryPage() {
		var all = [];
		for (var p = 1; p <= pages; p++) {
			all.push(fetchPage(p));
		}
		return Promise.all(all);
	}

	// Before the first card of a later page, so the grid stays in collection
	// order (the banner card sits inside page 1 and the More Products card
	// stays last).
	function addCards(page, pageCards) {
		var cards = grid.querySelectorAll('.single-product--card[data-tags]');
		var seen = {};
		var before = moreCard;
		for (var c = 0; c < cards.length; c++) {
			seen[cardKey(cards[c])] = true;
			if(before === moreCard && parseInt(cards[c].getAttribute('data-page'), 10) > page) {
				before = cards[c];
			}
		}
		for (var i = 0; i < pageCards.length; i++) {
			// A product can move between pages if the catalogue changes mid-visit.
			if(seen[cardKey(pageCards[i])]) {
				continue;
			}
			seen[cardKey(pageCards[i])] = true;
			var card = document.importNode(pageCards[i], true);
			card.setAttribute('data-page', page);
			card.style.display = 'none';
			grid.insertBefore(card, before);
		}
	}

	function cardKey(card) {
		var link = card.querySelector('.product-link');
		return link ? link.getAttribute('href') : card.getAttribute('data-tags');
	}

	function remember() {
		try {
			if(paging.shownThrough > current) {
				sessionStorage.setItem(storageKey, JSON.stringify({ through: paging.shownThrough, y: window.scrollY }));
			} else {
				sessionStorage.removeItem(storageKey);
			}
		} catch (e) {
			// Blocked storage just means the added pages aren't restored.
		}
	}

	function restore() {
		var saved = null;
		try {
			saved = JSON.parse(sessionStorage.getItem(storageKey));
			sessionStorage.removeItem(storageKey);
		} catch (e) {
			return;
		}
		var navigation = window.performance && performance.getEntriesByType ? performance.getEntriesByType('navigation')[0] : null;
		var returning = navigation && (navigation.type === 'back_forward' || navigation.type === 'reload');
		if(!saved || !returning || !canFetch || !(saved.through > current)) {
			return;
		}

		// The browser would restore the scroll before the added pages are back.
		if('scrollRestoration' in history) {
			history.scrollRestoration = 'manual';
		}
		var wanted = [];
		for (var p = current + 1; p <= Math.min(saved.through, pages); p++) {
			wanted.push(p);
		}
		var fetchWanted = function() {
			return Promise.all(wanted.map(fetchPage));
		};
		// More than a couple of pages come quicker from the filter data, which
		// brings 250 products a request.
		(wanted.length > 2 ? fetchAll().then(fetchWanted) : fetchWanted()).then(function(results) {
			// Up to the first page that failed, so no gap is left in the grid.
			for (var r = 0; r < results.length && results[r]; r++) {
				paging.shownThrough = current + r + 1;
			}
			paging.refresh();
			window.scrollTo(0, saved.y);
		});
	}
}

// Hero Video Function

// The hero video is a multi-megabyte file sitting above the fold. Its <source>
// elements ship with data-src instead of src, so the element downloads nothing
// while the page loads. They are swapped in on window load, by which point the
// LCP image has been fetched and decided, and the video no longer competes with
// it for bandwidth on a throttled connection.
function heroVideo() {
	var video = document.querySelector('.hero-video');
	if(!video) {
		return;
	}

	var sources = video.querySelectorAll('source[data-src]');
	if(sources.length === 0) {
		return;
	}

	function start() {
		for (var i = 0; i < sources.length; i++) {
			sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
			sources[i].removeAttribute('data-src');
		}

		// Required: a media element ignores sources added after it was parsed
		// until load() re-runs the resource selection algorithm.
		video.load();

		// The autoplay attribute alone does not reliably restart playback after
		// load(), so ask explicitly. play() returns a promise in modern browsers
		// and rejects if autoplay is refused; the poster simply stays visible,
		// so swallow it rather than throwing into the console.
		var playing = video.play();
		if(playing && typeof playing.catch === 'function') {
			playing.catch(function() {});
		}
	}

	// application.js is deferred, so it runs before load - but guard anyway in
	// case that ever changes, or the event has already fired on a cached view.
	if(document.readyState === 'complete') {
		start();
	} else {
		window.addEventListener('load', start);
	}
}

function formSuccess() {
	var panel = document.querySelector('.product-enquiry--panel');
	var background = document.querySelector('.product-enquiry--background');
	if (!panel || !background) return;
	panel.querySelector('.form--success').style.display = 'block';
	panel.querySelector('.form--fields').style.display = 'none';
	panel.querySelector('.product--button').innerHTML = '<div class="p20 text-center bt1 bg-white pos-rel z-2">Success</div>';
	panel.classList.add('is-active');
	background.classList.add('is-active');
}

// Browser Height Function 

window.addEventListener('resize', browserHeight);

function browserHeight() {
    const doc = document.documentElement
    doc.style.setProperty('--vh', (window.innerHeight*.01) + 'px');
}

function mobileDropdowns() {
	var dropdowns = document.querySelectorAll('.mobile-dropdown');
	for (i = 0; i < dropdowns.length; i++) {
  		dropdowns[i].addEventListener("click", function(e) { 
  			e.target.closest('.mobile-dropdown').classList.toggle('active');
  		});
  	}
}


function pageScrolling() {
	var cart = document.querySelector('.fixed--cart');
	if(!cart) return;
	cart.classList.add('load-in');
	cart.classList.add('fade-in');
	let scrolling = false;
	window.addEventListener('scroll',(event) => {
	    scrolling = true;
	});

	setInterval(() => {
	  if(scrolling) {
	    scrolling = false;
	    scrollingFunction();
	  }
	},300);
}

function scrollingFunction() {
	var pageTitle = document.querySelector('.page-title--text');
	 
	if(document.documentElement.scrollTop > 150) {
		pageTitle.classList.add('fade-in');
	} else {
		pageTitle.classList.remove('fade-in');
	}
}

function newsletterSignup() {
	// TY-109: collection pages don't load jQuery (layout/theme.liquid).
	if(!window.jQuery) {
		return;
	}
	$('form.subscribe-form').submit(function(e) {
	  var $this = $(this);
	  $.ajax({
	      type: "GET",  
	      url: "https://agdesignerjeweller.us3.list-manage.com/subscribe/post-json?u=58a4431d2675e52f6e2f4c59b&amp;id=aefb3c07ae&c=?",
	      data: $this.serialize(),
	      dataType    : 'json',
	      contentType: "application/json; charset=utf-8",
	      error       : function(err) {$('.subscribe-form .signup-message').html('<p class="message small failed">Please enter a valid email address & ensure you are not already signed up.</p>'); },
	      success     : function(data) {
	          if (data.result != "success") {
	          	$('.subscribe-form .signup-message').html('<p class="message small failed">Please enter a valid email address & ensure you are not already signed up.</p>');
	          } else {
	            $('.subscribe-form').html('<p class="message small">Thank You for signing up.</p>'); 
	          }
	      }
	  });
	  return false;
	});
}

// Form Functionality

function enquiryFormFunctions() {
	var success = document.querySelector('.contact-form--success');
	var errors = document.querySelector('.contact-form--errors');
	var enquiryPanel = document.querySelector('.product-enquiry--panel');
	var enquiryBackground = document.querySelector('.product-enquiry--background');
	var closePopup = document.querySelector('.close--popup');
	var popup = document.querySelector('.success--popup');

	if(success.innerHTML != '') {
		popup.classList.add('is-active');
		setTimeout(function(){ 
			popup.classList.add('fade-in');
		}, 100);
	}

	closePopup.addEventListener("click", function(e) { 
		popup.classList.remove('fade-in');
		setTimeout(function(){ 
			popup.classList.add('is-active');
		}, 500);
	});

	if(errors.innerHTML != '') {
		if (enquiryPanel) enquiryPanel.classList.add('is-active');
		if (enquiryBackground) enquiryBackground.classList.add('is-active');
	}
}

// Archive Page Functionality

function archiveRingFunction() {
	openSidePanel();  	
}

// Contact form navigation

function contactPageFunctions() {
	var map = document.querySelector('.show-map--panel');
	var dropdown = document.querySelector('.ring-type--dropdown');

	dropdown.addEventListener("change", function(e) { 
		if(e.target.value == 'Engagement ring') {
			var fields = document.querySelector('.engagement-ring--fields');
			var height = fields.querySelector('.inner').offsetHeight;
			fields.style.height=height+'px';
		}
	});

	map.addEventListener("click", function(e) { 
		document.querySelector('.map--container').classList.add('is-active');
		if(window.innerWidth < 768) {
			window.scrollTo(0,document.querySelector('#showroom').offsetTop); 
		} 
	});
	map.addEventListener("mouseover", function(e) { 
		document.querySelector('.map--container').classList.add('is-hover');
	});
	map.addEventListener("mouseout", function(e) { 
		document.querySelector('.map--container').classList.remove('is-hover');
	});
}

// Featured Collection Functionality 

function featuredCollections() {
	var links = document.querySelectorAll('.collection-navigation--links .link');
	for (i = 0; i < links.length; i++) {
  		links[i].addEventListener("click", function(e) { 
  			var currentLink = document.querySelector('.collection-navigation--links .link.active');
  			if(currentLink) {
  				currentLink.classList.remove('active');
  			}
			e.target.classList.add('active');
			var collection = e.target.getAttribute('data-title');
			var current = document.querySelector('.featured-products--collection.is-active');
			if(current) {
				current.classList.remove('is-active');
			}
			document.querySelector('.featured-products--collection[data-collection="'+collection+'"]').classList.add('is-active');
		});
	}
	var dropdown = document.querySelector('.collection-navigation--select');
	dropdown.addEventListener("change", function(e) { 
		var collection = dropdown.value;
		var current = document.querySelector('.featured-products--collection.is-active');
		if(current) {
			current.classList.remove('is-active');
		}
		if(collection == 'Shop All') {
			window.location.href = '/collections/all';
		} else {
			document.querySelector('.featured-products--collection[data-collection="'+collection+'"]').classList.add('is-active');
		}
	});	
}

// Open Panel Functionality

function openSidePanel() {
	var panel = document.querySelector('.product-enquiry--panel');
	var background = document.querySelector('.product-enquiry--background');
	var close = document.querySelector('.close-enquiry--form');
	var panelLinks = document.querySelectorAll('.open-side--panel');
	
	for (i = 0; i < panelLinks.length; i++) {
  		panelLinks[i].addEventListener("click", function(e) { 
  			if(e.target.getAttribute('data-title')) {
  				document.querySelector('.contact-panel--title').innerHTML = e.target.getAttribute('data-title');
  			}
			openPanel();
		});
	}
	
	background.addEventListener("click", function(e) { 
		closePanel();
	});

	close.addEventListener("click", function(e) { 
		closePanel();
	});

	function openPanel() {
		panel.classList.add('is-active');
		background.classList.add('is-active');
	}

	function closePanel() {
		panel.classList.remove('is-active');
		background.classList.remove('is-active');
	}

}

// Product Filtering Functions

function productFiltering() {
	var button = document.querySelector('.show-filters--button');
	var filterSidebar = document.querySelector('.product--sidebar');
	var filterContainer = document.querySelector('.product--container.container-with--sidebar')
	button.addEventListener("click", function(e) { 
		if(filterSidebar.classList.contains('is-active')) {
			filterSidebar.classList.remove('is-active');
			filterContainer.classList.remove('is-active');
			button.classList.remove('is-active');
		} else {
			filterSidebar.classList.add('is-active');
			filterContainer.classList.add('is-active');
			button.classList.add('is-active');
		}
	});

	var dropdowns =  document.querySelectorAll('.filtering--dropdown .header');

	for (i = 0; i < dropdowns.length; i++) {
  		dropdowns[i].addEventListener("click", function(e) { 
  			var parent = e.target.closest('.filtering--dropdown'); 
  			var options = parent.querySelector('.options'); 
  			var optionsInner = parent.querySelector('.options--inner'); 
  			var height = optionsInner.offsetHeight;
  			if(parent.classList.contains('is-active')) {
  				parent.classList.remove('is-active');
  				options.style.height =null; 
  			} else {
  				parent.classList.add('is-active');
  				options.style.height = height+'px';
  			}
  		});
  	}

	tagFiltering();
}

// Tag Filtering Functions

// Filters the products rendered on the page, plus those on the collection's
// other pages (fetched through collectionPages), against each card's data-tags.
// Nothing here touches the URL: the collection keeps one address, so no
// filtered duplicates are created for search engines to index.

function tagFiltering() {
	var sidebar = document.querySelector('.product--sidebar');
	var grid = document.querySelector('.product--grid');

	if(!sidebar || !grid) {
		return;
	}

	// Re-read by mergeOptions() when options from other pages are added.
	var options = sidebar.querySelectorAll('.selection[data-filter-value]');

	if(options.length === 0) {
		return;
	}

	// Null on a grid without pages, which behaves as a single page.
	var paging = collectionPaging;
	var cards = grid.querySelectorAll('.single-product--card[data-tags]');
	var banner = grid.querySelector('.collection-banner-card');
	var moreCard = grid.querySelector('.more-products');
	var pagination = document.querySelector('.collection-pagination');
	var resultCount = document.querySelector('.result--count');
	var emptyMessage = document.querySelector('.filter--empty');
	var clearWrapper = document.querySelector('.clear-filters--wrapper');
	var resetButton = document.querySelector('.filter-reset--button');
	var clearButtons = document.querySelectorAll('.clear-filters--button');
	var showFilters = document.querySelector('.show-filters--button');
	var badges = document.querySelectorAll('[data-count-for]');
	var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	var swapTimer = null;
	var loadingPages = false;
	var allPagesRequested = false;
	var pendingValues = [];

	if(paging) {
		paging.refresh = commitFilters;
		paging.onOptions = mergeOptions;
	}

	// Delegated, so options added from other pages respond too. Product Type
	// entries are .selection links without data-filter-value and are left alone.
	sidebar.addEventListener("click", function(e) {
		var option = e.target.closest('.selection[data-filter-value]');
		if(!option) {
			return;
		}
		e.preventDefault();
		option.classList.toggle('is-active');
		loadAllPages();
		applyFilters(true);
	});

	// The sidebar lists only the options this page's products have until the
	// other pages arrive, so they are fetched as soon as it is opened.
	if(showFilters) {
		showFilters.addEventListener("click", loadAllPages);
	}

	for (var c = 0; c < clearButtons.length; c++) {
		clearButtons[c].addEventListener("click", function(e) {
			e.preventDefault();
			for (var j = 0; j < options.length; j++) {
				options[j].classList.remove('is-active');
			}
			pendingValues = [];
			applyFilters(true);
		});
	}

	// A legacy tag URL redirects here from theme.liquid, handing over the tags it
	// carried in sessionStorage. Reapply them so the visitor's original filter
	// survives the redirect instead of being silently dropped. Changing the sort
	// (snippets/sortby.liquid) hands over the active filters the same way.
	// Read once and clear immediately, so a later refresh starts unfiltered.
	try {
		var pending = sessionStorage.getItem('ag:pending-filters');
		if(pending) {
			sessionStorage.removeItem('ag:pending-filters');
			pendingValues = pending.split('|');
			applyPending();
			loadAllPages();
		}
	} catch (e) {
		// Blocked storage just means no filter is restored; the page still works.
	}

	applyFilters(false);

	// Selects the handed-over values that have an option. The rest are kept,
	// because their option may only exist on another page of the collection.
	function applyPending() {
		var left = [];
		for (var v = 0; v < pendingValues.length; v++) {
			var found = false;
			for (var p = 0; p < options.length; p++) {
				if(options[p].getAttribute('data-filter-value') === pendingValues[v]) {
					options[p].classList.add('is-active');
					found = true;
				}
			}
			if(!found) {
				left.push(pendingValues[v]);
			}
		}
		pendingValues = left;
	}

	// TY-059: a filter has to search the whole collection, not just this page.
	// The other pages are fetched in the same sort order and their cards added
	// to the grid, hidden until a filter matches them, with any options only
	// their products have added to the sidebar. If a request fails the filter
	// still works on the pages that arrived.
	// TY-109: this used to run on every visit, fetching every other page of the
	// collection in the background. It now waits until the filters are opened
	// or one is handed over, so a visitor who only browses fetches nothing.
	function loadAllPages() {
		if(allPagesRequested || !paging || paging.pages < 2 || !paging.canFetch) {
			return;
		}
		allPagesRequested = true;
		loadingPages = true;
		paging.fetchAll().then(function() {
			applyPending();
			loadingPages = false;
			commitFilters();
		});
	}

	// Adds options this page doesn't have, in alphabetical order within their
	// group, and shows the group if this page had nothing in it.
	function mergeOptions(fetched) {
		var existing = {};
		for (var o = 0; o < options.length; o++) {
			existing[options[o].getAttribute('data-filter-value')] = true;
		}
		for (var i = 0; i < fetched.length; i++) {
			var value = fetched[i].getAttribute('data-filter-value');
			var dropdown = sidebar.querySelector('[data-filter-dropdown="' + fetched[i].getAttribute('data-filter-group') + '"]');
			if(existing[value] || !dropdown) {
				continue;
			}
			existing[value] = true;
			var inner = dropdown.querySelector('.options--inner');
			var option = document.importNode(fetched[i], true);
			option.classList.remove('is-active');
			var siblings = inner.querySelectorAll('.selection[data-filter-value]');
			var before = null;
			for (var s = 0; s < siblings.length; s++) {
				if(siblings[s].textContent.localeCompare(option.textContent, undefined, { sensitivity: 'base' }) > 0) {
					before = siblings[s];
					break;
				}
			}
			inner.insertBefore(option, before);
			dropdown.style.display = '';
			// An open panel has a fixed pixel height; grow it to fit.
			if(dropdown.classList.contains('is-active')) {
				dropdown.querySelector('.options').style.height = inner.offsetHeight + 'px';
			}
		}
		options = sidebar.querySelectorAll('.selection[data-filter-value]');
	}

	function activeGroups() {
		var groups = {};
		for (var i = 0; i < options.length; i++) {
			if(options[i].classList.contains('is-active')) {
				var key = options[i].getAttribute('data-filter-group');
				if(!groups[key]) {
					groups[key] = [];
				}
				groups[key].push({
					value: options[i].getAttribute('data-filter-value'),
					min: options[i].getAttribute('data-price-min'),
					max: options[i].getAttribute('data-price-max')
				});
			}
		}
		return groups;
	}

	// An option with a price range (TY-059) matches on the card's real price, so
	// a stale Price_ tag can't put a product in the wrong range. Only a card with
	// no price ($0) falls back to its tag. Anything else matches on its tag.
	function optionMatches(option, tags, price) {
		if(option.min !== null && price > 0) {
			return price >= parseInt(option.min, 10) && (option.max === null || price < parseInt(option.max, 10));
		}
		return tags.indexOf(option.value) !== -1;
	}

	// Values within a group are OR'd, groups are AND'd with each other.
	function matches(card, groups) {
		var tags = card.getAttribute('data-tags').split('|');
		var price = parseInt(card.getAttribute('data-price'), 10) || 0;
		for (var key in groups) {
			if(!groups.hasOwnProperty(key)) {
				continue;
			}
			var wanted = groups[key];
			var found = false;
			for (var i = 0; i < wanted.length; i++) {
				if(optionMatches(wanted[i], tags, price)) {
					found = true;
					break;
				}
			}
			if(!found) {
				return false;
			}
		}
		return true;
	}

	// Fade the grid out, swap which cards are visible while nothing is on
	// screen, then fade back in. Doing the swap behind the fade is what stops
	// the remaining cards visibly jumping as the grid reflows into the gaps.
	function applyFilters(animate) {
		if(!animate || reduceMotion) {
			commitFilters();
			return;
		}

		grid.classList.add('is-filtering');

		// A second click mid-fade just resets the timer; the grid is already
		// faded out, so the newer selection is the one that gets committed.
		if(swapTimer) {
			clearTimeout(swapTimer);
		}

		// Slightly longer than the 0.25s opacity transition in filter.scss.
		swapTimer = setTimeout(function() {
			swapTimer = null;
			commitFilters();
			requestAnimationFrame(function() {
				grid.classList.remove('is-filtering');
			});
		}, 260);
	}

	function commitFilters() {
		var groups = activeGroups();
		var total = 0;
		var visible = 0;

		for (var key in groups) {
			if(groups.hasOwnProperty(key)) {
				total += groups[key].length;
			}
		}

		// Pages fetched since the last refresh have added cards.
		cards = grid.querySelectorAll('.single-product--card[data-tags]');

		// Unfiltered, this page and those Load more added show (collectionPages).
		for (var i = 0; i < cards.length; i++) {
			var show = total > 0 ? matches(cards[i], groups) : (!paging || paging.isShown(cards[i]));
			if(show) {
				cards[i].style.display = '';
				visible++;
			} else {
				cards[i].style.display = 'none';
			}
		}

		for (var b = 0; b < badges.length; b++) {
			var badgeKey = badges[b].getAttribute('data-count-for');
			var count = badgeKey === 'total' ? total : (groups[badgeKey] ? groups[badgeKey].length : 0);
			badges[b].innerHTML = count > 0 ? '('+count+')' : '';
		}

		if(banner) {
			banner.style.display = total > 0 ? 'none' : '';
		}
		if(moreCard) {
			moreCard.style.display = total > 0 ? 'none' : '';
		}
		// Filtered results already cover every page.
		if(pagination) {
			pagination.style.display = total > 0 ? 'none' : '';
		}
		if(paging) {
			paging.updateButton(total > 0);
		}
		if(clearWrapper) {
			clearWrapper.style.display = total > 0 ? '' : 'none';
		}
		if(resetButton) {
			resetButton.style.display = total > 0 ? '' : 'none';
		}
		if(emptyMessage) {
			// The matches may still be on a page that hasn't arrived yet.
			emptyMessage.style.display = (total > 0 && visible === 0 && !loadingPages) ? '' : 'none';
		}
		// Unfiltered, the whole collection's count rather than the cards loaded so far.
		if(resultCount) {
			var unfiltered = parseInt(grid.getAttribute('data-total'), 10);
			resultCount.innerHTML = (total === 0 && unfiltered ? unfiltered : visible) + ' Results';
		}
		// Revealed cards still have unloaded data-src images.
		updateLazyImages();
	}
}

// Product Functions

function productFunctions() {
	var consultLink = document.querySelector('.how-it-works .ul-link');
	var enquire = document.querySelector('.product--enquiry');
	var enquiryPanel = document.querySelector('.product-enquiry--panel');
	var enquiryBackground = document.querySelector('.product-enquiry--background');
	var enquiryClose = document.querySelector('.close-enquiry--form'); 
	var variants =  document.querySelector('.select-variants--button'); 

	if (enquire) enquire.addEventListener("click", function(e) {
		openEnquiry();
	});  

	if (consultLink) consultLink.addEventListener("click", function(e) {
		if (!enquiryPanel) return;
		var subject = enquiryPanel.querySelector("input[name='contact[Type]']");
		if (!subject) return;
		e.preventDefault();
		var title = enquiryPanel.querySelector('.contact-panel--title');
		if (title) title.textContent = 'Make an Appointment';
		subject.value = subject.value.replace(/^(Ring Enquiry|Book an Appointment)/, 'Book an Appointment');
		openEnquiry();
	});

	var dropdowns = document.querySelector('.product-selection--dropdowns');
	
	if(dropdowns) {
		var label = dropdowns.getAttribute('data-label');
		if(label) {
			var lbl = document.createElement('label');
			lbl.innerHTML = label;
			dropdowns.querySelector('.selector-wrapper').prepend(lbl); 
		}             
	}

	if(variants) {
		var button = document.querySelector('button.product--button');
		if(button) {
			button.setAttribute('disabled', true);
		}

		if(document.querySelector('.size-dropdown')) {
			document.querySelector('.size-dropdown').addEventListener("change", function(e) { 
				var selection = e.target.value;
				console.log(selection)
				if(selection=='Other') {
					document.querySelector('.custom-wrapper').classList.add('active');
					document.querySelector('.product--variants').style.height='unset';
				}
			}); 
		}
	 	 
	 	variants.addEventListener("click", function(e) { 
			showVariants();
		}); 
	}
	if (enquiryBackground) enquiryBackground.addEventListener("click", function(e) {
		closeEnquiry();
	});

	if (enquiryClose) enquiryClose.addEventListener("click", function(e) {
		closeEnquiry();
	});  

	function openEnquiry() {
		if (enquiryPanel) enquiryPanel.classList.add('is-active');
		if (enquiryBackground) enquiryBackground.classList.add('is-active');
	}

	function closeEnquiry() {
		if (enquiryPanel) enquiryPanel.classList.remove('is-active');
		if (enquiryBackground) enquiryBackground.classList.remove('is-active');
	}

	function closePopup() {
		var popup = document.querySelector('.cart--popup');
	}

	if(document.querySelector('.product--price-guide')) {
		priceRangeSelection();
	}
}

function showVariants() {
	var button = document.querySelector('button.product--button');
	if(button) {
		button.removeAttribute('disabled');
	}
	document.querySelector('.select-variants--button').classList.add('is-hidden');
	document.querySelector('.product-pricing--variants').classList.add('is-active');
	var variants = document.querySelector('.product--variants');
	var height = variants.querySelector('.inner').offsetHeight;
	variants.style.height = height+'px'; 
}

// Price guide (snippets/price-guide.liquid): the row button opens the budget
// bands; picking one fills the row, closes the bands and shows the carat
// recommendation card. Changing budget fades the card's figures out and back.
function priceRangeSelection() {
	var guide = document.querySelector('[data-price-guide]');
	var toggle = guide.querySelector('.price-guide__toggle');
	var value = guide.querySelector('[data-price-guide-value]');
	var bands = guide.querySelectorAll('.price-guide__band');
	var result = guide.querySelector('[data-price-guide-result]');
	var swap;

	function setOpen(open) {
		guide.classList.toggle('is-open', open);
		toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
	}

	toggle.addEventListener('click', function() {
		setOpen(!guide.classList.contains('is-open'));
	});

	for (var i = 0; i < bands.length; i++) {
		bands[i].addEventListener('click', function() {
			var band = this;
			for (var j = 0; j < bands.length; j++) {
				bands[j].setAttribute('aria-pressed', bands[j] === band ? 'true' : 'false');
			}
			value.textContent = band.textContent;
			guide.classList.add('has-value');
			showRecommendation(band);
			// A beat to see the choice land before the bands fold away.
			setTimeout(function() {
				setOpen(false);
			}, 250);
		});
	}

	function showRecommendation(band) {
		var low = band.getAttribute('data-low');
		var wasShown = result.classList.contains('is-active');
		result.classList.add('is-active', 'is-changing');
		clearTimeout(swap);
		swap = setTimeout(function() {
			result.classList.toggle('is-high-value', !low);
			result.querySelector('[data-price-guide-band]').textContent = band.textContent;
			result.querySelector('[data-price-guide-low]').textContent = low || '';
			result.querySelector('[data-price-guide-high]').textContent = band.getAttribute('data-high');
			result.classList.remove('is-changing');
		}, wasShown ? 200 : 0);
	}
}

// Menu Functions

function menuFunctions() {
	var menu = document.querySelector('.menu-toggle--button');
	var masthead = document.querySelector('.masthead--container');
	var sidebar = document.querySelector('.side-menu--container');
	var background = document.querySelector('.menu--background');
	var mobile = document.querySelector('.mobile-menu-icon');
	var mobileOverlay = document.querySelector('.mobile--overlay');

	// Mobile menu 

	mobile.addEventListener("click", function(e) { 
		if(mobileOverlay.classList.contains('is-active')) {
			mobileOverlay.classList.remove('is-active');
			mobile.classList.remove('active');
		} else {
			mobileOverlay.classList.add('is-active');
			mobile.classList.add('active');
		}
	}); 

	// Mobile return menu

	var mobileReturn = document.querySelector('.return-to--menu');
	mobileReturn.addEventListener("click", function(e) { 
		document.querySelector('.mobile--submenu.active').classList.remove('active');
		document.querySelector('.mobile--submenu.primary-submenu').classList.add('active');
		mobileReturn.classList.remove('active');
	}); 

	// Mobile menu sublinks

	var mobileLinks = document.querySelectorAll('.primary-submenu.mobile--submenu .menu-item a');
	var mSubLinks = ['Shop', 'Engagement', 'Wedding', 'Bespoke'];
	for (i = 0; i < mobileLinks.length; i++) {
		mobileLinks[i].addEventListener("click", function(e) { 
			if(mSubLinks.includes(e.target.innerHTML)) {
				console.log('internal link clicked')
				e.preventDefault();
				var title = e.target.innerHTML;

				var current = document.querySelector('.mobile--submenu.active');
				if(current) {
					current.classList.remove('active');
				}
				var next = document.querySelector('.mobile--submenu[data-menu="'+title+'"]');
				if(next) {
					next.classList.add('active');
					mobileReturn.querySelector('.title').innerHTML=title;
					mobileReturn.classList.add('active');
				}
			}
		}); 
	}

	// Menu Open & Close

	menu.addEventListener("click", function(e) { 
		if(masthead.classList.contains('is-active')) {
			closeMenu();
		} else {
			openMenu();
		}
	});  

	background.addEventListener("click", function(e) { 
		closeMenu();
	});  

	function openMenu() {
		masthead.classList.add('is-active');
		sidebar.classList.add('is-active');
		background.classList.add('is-active');
	}

	function closeMenu() {
		masthead.classList.remove('is-active');
		sidebar.classList.remove('is-active');
		background.classList.remove('is-active');
		masthead.classList.remove('with-submenu');
		sidebar.classList.remove('with-submenu');
		if(document.querySelector('.sidebar--menu .menu-link.active')) {
			document.querySelector('.sidebar--menu .menu-link.active').classList.remove('active');
		}
		if(document.querySelector('.submenu.is-active')) {
			document.querySelector('.submenu.is-active').style.height = '0px';
			document.querySelector('.submenu.is-active').classList.remove('is-active');
		}
	}

	// Menu Submenu

	var links = document.querySelectorAll('.sidebar--menu .menu-item a');
	var subLinks = ['Shop', 'Guide', 'Engagement', 'Wedding', 'Bespoke']
	for (i = 0; i < links.length; i++) {
		links[i].addEventListener("click", function(e) { 
			if(subLinks.includes(e.target.innerHTML)) {
				e.preventDefault();
				var title = e.target.innerHTML;
				var current =document.querySelector('.sidebar--menu .menu-item a.active');
				if(current) {
					current.classList.remove('active');
				}
				e.target.classList.add('active');
				openSubmenu(title);
			}
		}); 
	}

	function openSubmenu(title) {
		var title = title.split(" ")[0];
		var previous = document.querySelector('.sidebar--secondary-menu .submenu.is-active');
		if(previous) {
			previous.classList.remove('is-active');
			previous.style.height = '0px';
		}
		var current = document.querySelector('.sidebar--secondary-menu .submenu[data-id="'+title+'"]');
		if(current) {
			current.classList.add('is-active');
			current.style.height = current.querySelector('.inner-container').offsetHeight+'px';
		}
		masthead.classList.add('with-submenu');
		sidebar.classList.add('with-submenu');
	} 

	// Collection Menu Items

	var collectionLinks = document.querySelectorAll('.collection--menu-item');
	var productSidebar = document.querySelector('.menu-product--sidebar');
	var closeSidebar = document.querySelectorAll('.close-product--sidebar');
	

	for (i = 0; i < collectionLinks.length; i++) {
		collectionLinks[i].addEventListener("mouseover", function(e) {
			collectionMouseOver(e.target);
		}); 
	}

	for (i = 0; i < closeSidebar.length; i++) {
		closeSidebar[i].addEventListener("mouseover", function(e) {
			closeProductSidebar();
		}); 
	}

	function collectionMouseOver(target) {
		var current = document.querySelector('.collection--menu-item.active');
		var currentCollection = document.querySelector('.product-menu--container.is-active');
		var collectionTitle = target.innerHTML;	
		var collection = document.querySelector('.product-menu--container[data-title="'+collectionTitle+'"]');

		if(current) {
			current.style.height='';
			current.classList.remove('active');
		}

		if(currentCollection) {
			currentCollection.classList.remove('is-active');
		}

		if(collection) {
			var height = collection.querySelector('.product-menu--inner').offsetHeight; 
			collection.style.height=height+'px';
			collection.classList.add('is-active');
		}

		target.classList.add('active');
		productSidebar.classList.add('is-active');

	} 

	function closeProductSidebar() {
		productSidebar.classList.remove('is-active');
		var current = document.querySelector('.collection--menu-item.active');
		if(current) {
			current.classList.remove('active');
		}
	}
}

// Event Listeners

function eventListeners() {
	var tabs = document.querySelectorAll('.product-information--tabs .information--title');
	for (i = 0; i < tabs.length; i++) {
  		tabs[i].addEventListener("click", function(e) { 
  			if(!e.target.classList.contains('active')) {
  				document.querySelector('.information--title.active').classList.remove('active');
  				e.target.classList.add('active');
  				var tab = e.target.getAttribute('data-title');
  				document.querySelector('.product-information--tabs .information.active').classList.remove('active');
  				document.querySelector('.product-information--tabs .information[data-info="'+tab+'"]').classList.add('active');
  			}
  		});  
	}
	var articleImages = document.querySelectorAll('.carousel-images .lazy');
	for (var i = 0; i < articleImages.length; i++) {
		lazyLoadInstance.load(articleImages[i]);
	}
}

// Sitewide Carousels & Carousel Navigation

var pagination;
var productCarousel;

function initialiseCarousels() {
	// TY-109: collection pages don't load Swiper (layout/theme.liquid).
	if(typeof Swiper === 'undefined') {
		return;
	}
	const articleCarousel = new Swiper('.article--carousel', {
	  	loop: true,
	  	spaceBetween: 20,
	  	speed:1000,
	  	slidesPerView:'auto',
	  	pagination: {
			el: '.swiper-pagination',
		},
		navigation: {
			nextEl: '.article-carousel-next',
			prevEl: '.article-carousel-prev', 
		}
	});

	// Before the carousels are built, so they are built at the gallery's real size.
	fitProductGalleryToScreen();

	// The thumbnails used to be desktop only, where they are the vertical rail
	// beside the photo. They now show on mobile as well, under the photo, so the
	// shopper can see how many photos there are and jump to one instead of
	// reading a "1 / 5" - which is the only clue there was. Horizontal is the
	// base so the mobile strip scrolls sideways; the breakpoint puts the desktop
	// rail back exactly as it was.
	//
	// 4.2 across rather than a fixed thumbnail width: the strip then fills the
	// screen whatever its size, and the fraction of a fifth thumbnail showing at
	// the edge is what tells you there are more to scroll to.
	//
	// The mouse wheel scrolls the strip (TY-083). On desktop the gallery is now
	// one sticky column no taller than the screen, so a product with more
	// thumbnails than fit has the rest out of sight below. releaseOnEdges hands
	// the wheel back to the page at either end, and a strip that fits entirely
	// is locked by Swiper, so on most products the wheel just scrolls the page.
	//
	// Small desktop, 769px up to 1200px (TY-083): the strip stays under the photo
	// so the photo can take the column's full width, with fixed-size thumbnails
	// ('auto' takes the 118px width set in snippets/product-carousel-styles.liquid,
	// which the gallery's sizing depends on). The rail goes beside the photo
	// from 1200px. Each breakpoint names its direction: Swiper applies only the
	// matching breakpoint's settings on top of the current ones, so leaving it
	// out would keep the strip vertical when the window narrows past 1200px.
	pagination = new Swiper(".product--pagination", {
        direction: "horizontal",
        slidesPerView: 4.2,
        slideToClickedSlide: true,
    	spaceBetween: 8,
    	mousewheel: {
    		releaseOnEdges: true
    	},
        breakpoints: {
	    769: {
	      	direction: "horizontal",
	      	slidesPerView: 'auto',
	      	spaceBetween: 8,
	    },
	    1200: {
	      	direction: "vertical",
	      	slidesPerView: 'auto',
	      	spaceBetween: 30,
	    }
	  }
    });
	
	productCarousel = new Swiper(".product--carousel", {
        direction: "horizontal",
        speed:1000,
        init: false,
        // Pinch to zoom, double tap to zoom and drag the photo around, straight
        // on the product image. The client asked for a photo to behave the way
        // it does in a phone's camera roll, where you do not press anything
        // first - before this you had to open the overlay and then tap, and the
        // zoomed photo could not be moved. maxRatio 3 matches the depth the
        // overlay has always zoomed to. Mobile only: productCarouselZoom()
        // turns it off above the breakpoint, where this is the vertical desktop
        // carousel and zooming on it was never offered.
        zoom: {
        	maxRatio: 3
        },
        // No "1 / 6" counter any more: the thumbnail strip under the photo shows
        // how many there are and rings the one you are on, so the counter was
        // saying the same thing again in a row of its own.
        //
        // No autoHeight either: the frame is one fixed square, so the gallery
        // holds its height instead of moving as you scroll between a 1:1 ecom
        // shot and a 4:5 model shot.
        //
        // Desktop slides in 400ms rather than the full second (TY-083: "slow
        // load time when clicking between images"). The desktop carousel runs
        // vertically, so clicking from the first thumbnail to the fifth scrolled
        // past three photos for a whole second before the one you wanted
        // arrived. Mobile keeps its 1000ms swipe.
        breakpoints: {
	    768: {
	      	direction: "vertical",
	      	speed: 400,
	    }
	  }
    });

	productCarousel.on('init', function() { carouselNav(); productCarouselZoom(); });
	productCarousel.on('slideChange', function (swiper) {
	  	var next = swiper.activeIndex+1;
	  	var thumb = document.querySelector('.product-pagination .swiper-slide:nth-child('+next+')');
	  	var current = document.querySelector('.product-pagination .swiper-slide.is-active');

	  	// Both were read straight into .classList before, so a product whose
	  	// thumbnails and photos ever fell out of step threw here and took the rest
	  	// of the handler - including the counter - down with it.
    	if (current) current.classList.remove('is-active');
    	if (thumb) thumb.classList.add('is-active');

    	keepThumbnailInView(swiper.activeIndex);
	});
	productCarousel.init();
	zoomTouchGuard(productCarousel, document.querySelector('.product--carousel'));
	window.addEventListener('resize', productCarouselZoom);
	preloadProductGallery();
	productHoverZoom();
}

// TY-083: hover zoom on the desktop gallery, made to behave like LOHR's - the
// client's reference (lohrjewellery.com.au, their hover-zoom.js). A 300px lens
// centred on the mouse follows it anywhere over the photo, running past the
// photo's edge if need be, and shows the photo at three times the size that
// would fill the lens. The point under the mouse sits at the same place in the
// lens as it does in the photo - at the photo's left edge it is at the lens's
// left edge - so the lens is always full of photo, even at a corner.
//
// Two differences, both because A.G's photos are not all one shape:
// - LOHR's photo fills its frame, so it measures the mouse against the frame.
//   Here a photo can be shorter than its frame, so the mouse is measured
//   against where the photo is actually drawn, and over the white space below
//   it the lens goes away, as LOHR's does when the mouse leaves the photo.
// - LOHR crops the photo square inside the lens, so the top and bottom of an
//   upright photo can never be zoomed. Here the whole photo is used, its
//   shorter side filling the lens as a square photo's does on LOHR.
//
// The lens shows data-zoom-image, the 2400px photo, fetched on first hover. The
// photo already on screen is layered underneath it, so the lens is never empty
// while the larger one arrives - it just sharpens.
//
// Mouse only: a finger has pinch to zoom on mobile, and the CSS keeps the lens
// hidden below the desktop breakpoint whatever happens here.
var PRODUCT_ZOOM_SCALE = 3;

function productHoverZoom() {
	var carousel = document.querySelector('.product--carousel');

	if (!carousel || !productCarousel || !productCarousel.wrapperEl) return;

	var desktop = window.matchMedia('(min-width: 769px)');
	var lens = document.createElement('div');
	var view = document.createElement('div');
	var lensImage = null;

	lens.className = 'product-zoom-lens';
	view.className = 'product-zoom-lens__image';
	lens.setAttribute('aria-hidden', 'true');
	lens.appendChild(view);
	// On the body, as LOHR's is: fixed to the mouse, it can run past the edge of
	// the gallery and over the header without being cut off or drawn under it.
	document.body.appendChild(lens);

	function hide() {
		lens.classList.remove('is-active');
		carousel.classList.remove('is-zooming');
	}

	// Where the photo is drawn inside its img. The img fills the whole frame and
	// the photo is fitted inside it (object-fit: contain), so the img's own box is
	// the frame, not the photo. The fit and position are read back from the CSS
	// rather than assumed - cover is handled too - so changing them there cannot
	// misalign the lens.
	function photoRect(image) {
		var box = image.getBoundingClientRect();
		var width = image.naturalWidth;
		var height = image.naturalHeight;

		if (!width || !height || !box.width || !box.height) return null;

		var style = window.getComputedStyle(image);
		var fit = (style.objectFit === 'cover' ? Math.max : Math.min)(box.width / width, box.height / height);
		var position = style.objectPosition.split(' ');
		var alignX = parseFloat(position[0]);
		var alignY = parseFloat(position[1]);

		alignX = isNaN(alignX) ? 0.5 : alignX / 100;
		alignY = isNaN(alignY) ? 0.5 : alignY / 100;

		return {
			left: box.left + (box.width - width * fit) * alignX,
			top: box.top + (box.height - height * fit) * alignY,
			width: width * fit,
			height: height * fit
		};
	}

	carousel.addEventListener('pointermove', function(event) {
		// buttons: a mouse dragging the carousel to the next photo, which the
		// lens would otherwise chase across the slide change.
		if (event.pointerType !== 'mouse' || event.buttons || !desktop.matches || productCarousel.animating) return hide();

		var slide = productCarousel.slides[productCarousel.activeIndex];
		// .loaded is LazyLoad's: until then the img is the placeholder.
		var image = slide && slide.querySelector('img.loaded');
		var photo = image && photoRect(image);

		if (!photo ||
			event.clientX < photo.left || event.clientX > photo.left + photo.width ||
			event.clientY < photo.top || event.clientY > photo.top + photo.height) return hide();

		if (image !== lensImage) {
			lensImage = image;
			var large = image.getAttribute('data-zoom-image');
			var layers = 'url("' + image.currentSrc + '")';

			if (large && large !== image.currentSrc) layers = 'url("' + large + '"), ' + layers;
			view.style.backgroundImage = layers;
		}

		lens.classList.add('is-active');
		carousel.classList.add('is-zooming');

		// Measured once showing - display:none has no size. outer centres the
		// lens on the mouse; inner is the photo's window, inside the border.
		var outer = lens.offsetWidth;
		var inner = lens.clientWidth;
		var scale = Math.max(inner / image.naturalWidth, inner / image.naturalHeight) * PRODUCT_ZOOM_SCALE;
		var width = image.naturalWidth * scale;
		var height = image.naturalHeight * scale;
		// Where the mouse is on the photo, 0 to 1 across and down.
		var x = (event.clientX - photo.left) / photo.width;
		var y = (event.clientY - photo.top) / photo.height;

		lens.style.left = (event.clientX - outer / 2) + 'px';
		lens.style.top = (event.clientY - outer / 2) + 'px';
		view.style.backgroundSize = width + 'px ' + height + 'px';
		// The same point of the photo sits under the mouse and at that same
		// fraction across the lens: LOHR's transform-origin zoom, as a background.
		view.style.backgroundPosition = (x * (inner - width)) + 'px ' + (y * (inner - height)) + 'px';
	});

	carousel.addEventListener('pointerleave', hide);
	productCarousel.on('transitionStart', hide);
	productCarousel.on('sliderMove', hide);
}

// TY-083: the desktop gallery is sized to the space between the header and the
// bottom of the window, so that every photo is seen whole. That space was
// assumed - 89px of header, 100vh of window - and the client found photos
// running off the bottom of the screen, visible only by scrolling to the end of
// the page. It is measured here instead:
// - the header, because the announcement bar on top of it can be switched off
//   or reworded in the theme settings, and longer text wraps;
// - the window, as actually visible: 100vh counts a horizontal scrollbar as
//   window;
// - a bar fixed over the bottom of the window - Shopify's preview bar on a
//   preview link, which is how the client reviews, or a cookie bar. Found by
//   what is under the gallery at the bottom edge, not by name, because Shopify
//   does not document the preview bar's markup and has changed it before.
// The results go to --pdp-gallery-top and --pdp-gallery-height, used by the
// desktop rules in snippets/product-carousel-styles.liquid; until this runs,
// those fall back to 89px and 100vh as before.
function fitProductGalleryToScreen() {
	var column = document.querySelector('.detailed-product--single .product-gallery--column');
	var masthead = document.getElementById('shopify-section-masthead');
	var root = document.documentElement;
	var queued = false;

	if (!column) return;

	// How much of the window's bottom edge a fixed bar covers under the gallery.
	// Only something that starts in the bottom fifth of the window counts as a
	// bar: a full-screen overlay - the newsletter popup, an open drawer - starts
	// at the top and is ignored, or the gallery would shrink to nothing behind it.
	function bottomBar(windowHeight) {
		var rect = column.getBoundingClientRect();
		var element = document.elementFromPoint(rect.left + rect.width / 2, windowHeight - 1);

		while (element && element !== document.body && element !== root) {
			if (window.getComputedStyle(element).position === 'fixed') {
				var top = element.getBoundingClientRect().top;
				return top >= windowHeight * 0.8 ? windowHeight - top : 0;
			}
			element = element.parentElement;
		}

		return 0;
	}

	function measure() {
		queued = false;

		var windowHeight = root.clientHeight;
		var header = masthead ? masthead.offsetHeight : 89;

		root.style.setProperty('--pdp-gallery-top', header + 'px');
		root.style.setProperty('--pdp-gallery-height', Math.max(0, windowHeight - header - bottomBar(windowHeight)) + 'px');
	}

	function queue() {
		if (queued) return;
		queued = true;
		window.requestAnimationFrame(measure);
	}

	measure();
	window.addEventListener('resize', queue);
	window.addEventListener('load', queue);
	// The header changing height without the window changing, and the preview
	// bar or a cookie bar arriving after the page has loaded, which they do.
	if (window.ResizeObserver && masthead) new ResizeObserver(queue).observe(masthead);
	if (window.MutationObserver) new MutationObserver(queue).observe(document.body, { childList: true });
}

// TY-083: on desktop every gallery photo is downloaded once the page has
// loaded, so clicking a thumbnail shows a photo that is already there. Before,
// nothing was fetched until it was on screen - and the slides that are not
// showing are clipped by the carousel, so LazyLoad never saw them until they
// were already sliding in: each click waited for the slide, then the download,
// then the fade.
//
// Waits for the window load event so the photo you land on and the rest of the
// page go first. Moving the mouse over the gallery starts it sooner, since that
// is the moment someone is about to click. LazyLoad skips any photo it has
// already loaded, so the two never fetch the same one twice.
//
// Desktop only: the ticket is about desktop, and on a phone this would cost
// data for photos the visitor may never swipe to.
function preloadProductGallery() {
	// Thumbnails too: the strip can be taller than the sticky gallery, and one
	// scrolled into view should not arrive blank.
	var images = document.querySelectorAll('.product--carousel img.lazy, .product--pagination img.lazy');

	if (!images.length || !lazyLoadInstance) return;
	if (!window.matchMedia('(min-width: 769px)').matches) return;

	var done = false;

	function preload() {
		if (done) return;
		done = true;

		for (var i = 0; i < images.length; i++) {
			lazyLoadInstance.load(images[i]);
		}
	}

	if (document.readyState === 'complete') {
		preload();
	} else {
		window.addEventListener('load', preload);
	}

	var column = document.querySelector('.product-gallery--column');
	if (column) column.addEventListener('mouseenter', preload);
}

// A pinch is two fingers, and a Swiper carousel follows the first one - so
// spreading your fingers to zoom a photo would swipe to the next one at the same
// time, and the slide change would throw the zoom away again. Swiping is held
// off while a second finger is down and for as long as the photo stays zoomed,
// which is also what lets a zoomed photo be dragged around instead of flicked
// past. Lifting your fingers and zooming back out gives swiping straight back.
//
// Shared with the zoom overlay in snippets/product-gallery.liquid, which has the
// same two carousels-and-fingers problem.
function zoomTouchGuard(swiper, element) {
	if (!swiper || !swiper.zoom || !swiper.wrapperEl || !element) return;

	var down = [];
	var pinching = false;

	// zoomChange hands over the new scale, and it has to be used: reading
	// swiper.zoom.scale during that event gives the OLD one, because Swiper emits
	// from inside the setter before it stores the value. Taking it from there
	// left swiping switched off after zooming back out.
	function refresh(scale) {
		var current = typeof scale === 'number' ? scale : swiper.zoom.scale;

		swiper.allowTouchMove = !pinching && current === 1;
	}

	element.addEventListener('pointerdown', function(event) {
		if (down.indexOf(event.pointerId) === -1) down.push(event.pointerId);
		if (down.length > 1) pinching = true;
		refresh();
	}, true);

	// Fingers are often lifted away from the carousel, so releases are watched on
	// the document - missing one would leave swiping switched off for good.
	['pointerup', 'pointercancel'].forEach(function(name) {
		document.addEventListener(name, function(event) {
			var at = down.indexOf(event.pointerId);
			if (at !== -1) down.splice(at, 1);
			if (down.length === 0) pinching = false;
			refresh();
		}, true);
	});

	// Swiper hands its own instance to every listener first, so the scale is the
	// second argument - the same shape as the slideChange handler above.
	swiper.on('zoomChange', function(instance, scale) { refresh(scale); });
}

// Zooming belongs to the mobile carousel only. Above the breakpoint the same
// Swiper becomes the vertical desktop gallery, which has never zoomed in place -
// the + button opens the overlay for that - so it is switched back off there.
var productCarouselZoomOn = null;

function productCarouselZoom() {
	// wrapperEl is the test for "there is actually a product carousel on this
	// page". initialiseCarousels() runs everywhere, and on a page without one
	// Swiper still hands back an instance - calling zoom.enable() on that throws
	// and would take the rest of this file's start-up down with it.
	if (!productCarousel || !productCarousel.zoom || !productCarousel.wrapperEl) return;

	var mobile = window.matchMedia('(max-width: 768px)').matches;

	if (mobile === productCarouselZoomOn) return;
	productCarouselZoomOn = mobile;

	if (mobile) {
		productCarousel.zoom.enable();
	} else {
		productCarousel.zoom.out();
		productCarousel.zoom.disable();
	}
}

// On mobile the thumbnails are a strip about four wide, so on a product with
// more photos than that the current one can be off the side of the screen -
// which defeats the point of marking it. The strip is scrolled to bring it back
// into view, and only when it is genuinely out of view, so swiping through the
// first few photos does not make the strip jump about underneath.
function keepThumbnailInView(index) {
	if (!pagination || !pagination.slides || !pagination.slides.length) return;

	var slide = pagination.slides[index];
	var strip = pagination.el;

	if (!slide || !strip) return;

	var s = slide.getBoundingClientRect();
	var c = strip.getBoundingClientRect();

	// Measured rather than asked of Swiper: the strip is four-and-a-bit thumbnails
	// wide, and Swiper counts that trailing fraction as a visible slide, so the
	// fifth thumbnail was left sitting a fifth on screen. Both axes, because the
	// same rail runs vertically on desktop.
	if (s.left >= c.left - 1 && s.right <= c.right + 1 &&
		s.top >= c.top - 1 && s.bottom <= c.bottom + 1) return;

	pagination.slideTo(index);
}

function carouselNav() {
	pagination.on('click', function(swiper) {
    	var slide = this.clickedIndex;
    	// No speed passed, so a click uses the carousel's own: 400ms on
    	// desktop, 1000ms on mobile as before (TY-083).
    	productCarousel.slideTo(slide);
    });
}